import React from 'react'
import { URL_CTRL_HIDRIC } from '../../router/Url';

export const GetListMEdidores = ({empresa}) => {
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_CTRL_HIDRIC+'getmedidoresglobal',{
      method: 'POST',
      headers: {
        'authorization': "paico2021",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        empresa: empresa
      })
    })
    let responsito = await query.json();
    // console.log(responsito)

    if(responsito.success){
      resolve(responsito.body)
    }else{
      resolve(null)
    }
  })
}
